(() => {
  const selector = 'img.gfa-media__source';

  const fillMissingAlt = (root) => {
    const images = [];

    if (root.nodeType === Node.ELEMENT_NODE && root.matches(selector)) {
      images.push(root);
    }

    if (root.querySelectorAll) {
      images.push(...root.querySelectorAll(selector));
    }

    images.forEach((image) => {
      if (image.hasAttribute('alt') && image.alt.trim()) return;

      const slide = image.closest('.gfa-carousel__slide');
      const slides = slide ? Array.from(slide.parentElement.children) : [];
      const position = slides.indexOf(slide) + 1;
      image.alt = position > 0 ? `TrainBot Instagram post ${position}` : 'TrainBot Instagram post';
    });
  };

  fillMissingAlt(document);

  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach(fillMissingAlt);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
